import React from 'react'
import HeroSection from './Components/HeroSection';
import { useGlobalContext } from './context';
import { useEffect } from 'react';

const About = () => {
  // const data ={
  //   tdata: "Here You know",
  //   name: "About",
  //   image: "./photos/about.png"
  // }

  const {updateAboutPage} = useGlobalContext();
  useEffect (()=>{
    updateAboutPage();
  }, []);
  return (
    <>
          <HeroSection/>
    </>
    
  )
}

export default About;